import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectActivePaperOptionForVariantId } from '../../../_redux-papers';
import { selectActiveSizeOptionForVariantId } from '../../../_redux-sizes';
import { VariantOption } from '../../../VariantOption';
import { ChangeVariantWindow } from '../../change-variant-window/ChangeVariantWindow';
import styles from './PhotoPrintsGroupWindowPanelHeader.module.scss';

const _PhotoPrintsGroupDetailWindowHeader = ({ size, paper, groupId }: Props) => {

    const { t } = useTranslation();
    const [isEditWindowOpen, setEditWindowOpen] = useState(false);

    return (
        <div className={styles.panelHeading}>
            <Icon className={styles.icon} type='shopping-cart' size='large' strokeWidth={2} />
            <div className={styles.heading} onClick={() => setEditWindowOpen(true)}>
                <h4 className={styles.groupName}>
                    {t('photo_prints.group_name', {
                        size: t(size.label!.key, size.label!.args),
                        paper: t(paper.name.key, paper.name.args)
                    })}
                </h4>
                <Icon type='general-ui-cog' strokeWidth={1} className={styles.groupEdit} />
            </div>

            {isEditWindowOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow
                        close={() => setEditWindowOpen(false)}
                        groupId={groupId} sizeId={size.value} paperId={paper.value} />
                </WindowStackItem>
            )}
        </div>
    );
};

type OwnProps = {
    groupId: string;
    variantId: string;
};

type Props = OwnProps & {
    size: VariantOption;
    paper: VariantOption;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    size: selectActiveSizeOptionForVariantId(state, ownProps.variantId)!,
    paper: selectActivePaperOptionForVariantId(state, ownProps.variantId)!
});

export const PhotoPrintsGroupWindowPanelHeader = connect(
    mapStateToProps
)(_PhotoPrintsGroupDetailWindowHeader);